import { useQuery } from "@tanstack/react-query";

import { cancelRequestOnSignal } from "@/apiUtils/cancelableQuery";
import useApiClient from "@/hooks/useApiClient";

type DataAssetSealogSearchOptions = {
  dataAssetPublicId?: string | null;
  sealogSearchTerm: string;
  sealogEventValues: string[];
  sealogEventFreeTexts: string[];
  sealogEventOptionNames: string[];
  sealogEventOptionValues: string[];
  regex: boolean;
  enabled?: boolean;
};

export default function useDataAssetSealogSearch({
  dataAssetPublicId,
  sealogSearchTerm,
  sealogEventValues,
  sealogEventFreeTexts,
  sealogEventOptionNames,
  sealogEventOptionValues,
  regex,
  enabled = true,
}: DataAssetSealogSearchOptions) {
  const api = useApiClient();
  const effectiveSealogSearchTerm = sealogSearchTerm.trim();
  const hasSealogFilters =
    !!effectiveSealogSearchTerm ||
    sealogEventValues.length > 0 ||
    sealogEventFreeTexts.length > 0 ||
    sealogEventOptionNames.length > 0 ||
    sealogEventOptionValues.length > 0;

  const query = useQuery({
    queryKey: [
      "searchSealogEvent",
      dataAssetPublicId,
      effectiveSealogSearchTerm,
      sealogEventValues,
      sealogEventFreeTexts,
      sealogEventOptionNames,
      sealogEventOptionValues,
      regex,
    ],
    queryFn: ({ signal }) =>
      cancelRequestOnSignal(
        api.sealog.searchSealogEvent({
          dataAssetPublicId: dataAssetPublicId || "",
          sealogEventQuery: effectiveSealogSearchTerm,
          sealogEventValues,
          sealogEventFreeTexts,
          sealogEventOptionNames,
          sealogEventOptionValues,
          regex,
        }),
        signal
      ),
    enabled: enabled && !!dataAssetPublicId && hasSealogFilters,
    throwOnError: true,
    refetchOnWindowFocus: false,
    staleTime: 60_000,
  });

  return { query, effectiveSealogSearchTerm, hasSealogFilters };
}
